if (!customElements.get("ingredient-slider")) {
	class IngredientSlider extends HTMLElement {
		constructor() {
			super()

			var slider = this.querySelector(".ingredient-slider__slider")

			if (slider) {
				this.initSlider(slider)
			}
		}

		initSlider(slider) {
			var ingredient_slider = new Swiper(slider, {
				slidesPerView: 1,
				speed: 400,
				loop: true,
				loopFillGroupWithBlank: true,
				spaceBetween: 0,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 45,
					},
				},
				mousewheel: {
					forceToAxis: true,
				},
			})
		}
	}

	customElements.define("ingredient-slider", IngredientSlider)
}
